<template>
  <v-menu v-model="exporting" :disabled="!value[0]" :close-on-content-click="false" offset-y>
    <v-tooltip bottom slot="activator">
      <slot name="activator" slot="activator" @click.stop="exporting = true">
        <v-btn flat :disabled="!value[0]">
          <span>Export</span>
          <v-badge :value="!!value[0]">
            <span slot="badge">{{ value.length }}</span>
            <v-icon medium class="red--text text--darken-3">
              mdi-file-pdf-box
            </v-icon>
          </v-badge>
        </v-btn>
      </slot>
      <span> Export {{ value.length | pluralize('application') }} to PDF </span>
    </v-tooltip>
    <v-card>
      <v-card-title>
        <div>
          <span class="subheading">Exporting to PDF</span>
          <div class="">Please select sections to be included in the export.</div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-btn
          @click="toggleSection('profile')"
          color="success"
          :outline="!sectionIncluded('profile')"
          block
        >
          <v-icon left v-if="sectionIncluded('profile')">mdi-check</v-icon>
          <v-icon left v-else key="profile-icon">mdi-checkbox-blank-outline</v-icon>
          Profile
        </v-btn>

        <v-btn
          @click="toggleSection('screening_question')"
          color="success"
          :outline="!sectionIncluded('screening_question')"
          block
        >
          <v-icon left v-if="sectionIncluded('screening_question')">mdi-check</v-icon>
          <v-icon left v-else key="screening_question-icon">
            mdi-checkbox-blank-outline
          </v-icon>
          Screening Questions
        </v-btn>

        <v-btn
          @click="toggleSection('identity')"
          color="success"
          :outline="!sectionIncluded('identity')"
          block
        >
          <v-icon left v-if="sectionIncluded('identity')">mdi-check</v-icon>
          <v-icon left v-else key="identity-icon">mdi-checkbox-blank-outline</v-icon>
          Proof of Identity
        </v-btn>
        <v-btn
          @click="toggleSection('transcript')"
          color="success"
          :outline="!sectionIncluded('transcript')"
          block
        >
          <v-icon left v-if="sectionIncluded('transcript')">mdi-check</v-icon>
          <v-icon left v-else key="transcripts-icon">mdi-checkbox-blank-outline</v-icon>
          Academic Transcripts
        </v-btn>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn flat @click.stop="exporting = false">Cancel</v-btn>
        <v-btn color="primary" @click.stop="pdf">
          <v-icon left>mdi-file-pdf-box</v-icon>
          Export
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { generatedDocumentDownloads } from '@/mixins/generatedDocumentDownloads.js'

export default {
  mixins: [generatedDocumentDownloads],
  props: { value: { type: Array, default: () => [] } },

  data() {
    return {
      exporting: false,
      sections: ['profile', 'financial', 'screening_question', 'identity', 'transcript'],
    }
  },

  methods: {
    toggleSection(section) {
      const index = this.sections.indexOf(section)
      if (index >= 0) this.sections.splice(index, 1)
      if (index < 0) this.sections.push(section)
    },

    sectionIncluded(section) {
      return this.sections.indexOf(section) >= 0
    },

    pdf() {
      if (this.value && this.value.length > 1) this.createBundle()
      if (this.value && this.value.length === 1) this.newTab()
    },

    createBundle() {
      this.$store
        .dispatch('admin/documentBundles/create', {
          sections: this.sections,
          opportunityApplicationIds: this.value,
        })
        .finally(() => (this.exporting = false))
    },

    async newTab() {
      await this.handleGeneratedDocumentRequest(
        this.$http.get(`${this.$root.$api}/admin/applications/${this.value[0]}.pdf`, {
          params: {
            auth_token: this.$auth.getToken(),
            sections: this.sections,
          },
          responseType: 'blob',
        }),
        {
          openInline: true,
          pendingMessage: 'Your application document has been requested. You will receive an email with a download link.',
          errorMessage: `There was a problem generating the application PDF for application ${this.value[0]}.`,
        }
      )
      this.exporting = false
    },
  },
}
</script>
